(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-design-system"] && !Shopify.designMode) return;
  try {
    (() => {

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-sb-buy-now]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const original = button.textContent;
    const error = button.parentElement.querySelector('.sb-buy-error') || button.nextElementSibling;
    button.disabled = true; button.textContent = button.dataset.loading;
    if (error) error.hidden = true;
    try {
      const response = await fetch(button.dataset.addUrl + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.variant, quantity: Number(button.dataset.quantity || 1) }] })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || button.dataset.error);
      location.assign(button.dataset.cartUrl);
    } catch (issue) {
      if (error) { error.textContent = issue.message || button.dataset.error; error.hidden = false; }
      button.disabled = false; button.textContent = original;
    }
  });

  const instances = new Map();
  class SmartbuzzScroller {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('.sb-rail__track, .collection-list.slider, .product-grid.slider');
      this.controls = root.querySelector('.sb-rail__controls > div, .slider-buttons');
      if (!this.track || !this.controls) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.interactUntil = 0;
      this.toggle = document.createElement('button');
      this.toggle.type = 'button';
      this.toggle.className = 'sb-carousel-toggle';
      this.toggle.setAttribute('aria-controls', this.track.id);
      this.controls.append(this.toggle);
      this.toggle.hidden = this.motion.matches;
      this.updateToggle();
      this.motion.addEventListener('change', () => {
        this.paused = this.motion.matches; this.toggle.hidden = this.motion.matches; this.updateToggle();
      }, options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateToggle();
      }, options);
      root.addEventListener('mouseenter', () => { this.hovered = true; }, options);
      root.addEventListener('mouseleave', () => { this.hovered = false; }, options);
      root.addEventListener('click', event => {
        if (!event.target.closest('.sb-carousel-toggle')) this.interactUntil = Date.now() + 8000;
      }, options);
      this.track.addEventListener('wheel', () => { this.interactUntil = Date.now() + 8000; }, { ...options, passive: true });
      this.track.addEventListener('pointerdown', event => {
        this.interactUntil = Date.now() + 8000;
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input')) return;
        this.drag = { x: event.clientX, left: this.track.scrollLeft, moved: false };
      }, options);
      window.addEventListener('pointermove', event => {
        if (!this.drag) return;
        const delta = event.clientX - this.drag.x;
        if (Math.abs(delta) > 7) {
          this.drag.moved = true;
          this.track.classList.add('sb-carousel-dragging');
          this.track.style.scrollSnapType = 'none';
          this.track.scrollLeft = this.drag.left - delta;
        }
      }, options);
      const finishDrag = () => {
        if (!this.drag) return;
        this.suppressClick = this.drag.moved;
        this.drag = null;
        this.track.classList.remove('sb-carousel-dragging');
        this.track.style.scrollSnapType = '';
        this.interactUntil = Date.now() + 8000;
      };
      window.addEventListener('pointerup', finishDrag, options);
      window.addEventListener('pointercancel', finishDrag, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
      }, { ...options, capture: true });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: 0.3 });
      this.observer.observe(this.track);
      this.timer = setInterval(() => this.advance(), 3500);
    }
    updateToggle() {
      this.toggle.textContent = this.paused ? 'Play' : 'Pause';
      this.toggle.setAttribute('aria-label', this.paused ? 'Start automatic scrolling' : 'Pause automatic scrolling');
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }
    advance() {
      if (this.paused || this.motion.matches || !this.visible || this.hovered || document.hidden || this.drag || Date.now() < this.interactUntil) return;
      if (this.root.contains(document.activeElement) && document.activeElement !== this.toggle) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max < 2) return;
      const step = this.track.children[1] ? this.track.children[1].offsetLeft - this.track.children[0].offsetLeft : this.track.clientWidth;
      this.track.scrollTo({ left: this.track.scrollLeft >= max - 3 ? 0 : Math.min(max, this.track.scrollLeft + step), behavior: 'smooth' });
    }
    destroy() {
      clearInterval(this.timer); this.observer?.disconnect(); this.abort?.abort(); this.toggle?.remove();
    }
  }
  const setupProductAccordions = () => {
    document.querySelectorAll('.product__description[data-sb-details-label]').forEach(root => {
      if (root.dataset.sbAccordionReady || root.querySelector('details')) return;
      const nodes = Array.from(root.childNodes);
      const fragment = document.createDocumentFragment();
      let content;
      const addPanel = heading => {
        const panel = document.createElement('details');
        panel.className = 'sb-product-accordion';
        const summary = document.createElement('summary');
        if (heading) summary.append(heading);
        else summary.textContent = root.dataset.sbDetailsLabel;
        content = document.createElement('div');
        content.className = 'sb-product-accordion__content';
        panel.append(summary, content);
        fragment.append(panel);
      };
      addPanel();
      nodes.forEach(node => {
        if (node.nodeType === 1 && /^H[23]$/.test(node.tagName) && /care|faq|frequently|specifications|dimensions/i.test(node.textContent)) addPanel(node);
        else content.append(node);
      });
      Array.from(fragment.children).forEach(panel => {
        const body = panel.lastElementChild;
        if (!body.textContent.trim() && !body.querySelector('img,video,iframe,table') && !panel.firstElementChild.children.length) panel.remove();
      });
      root.append(fragment);
      root.dataset.sbAccordionReady = 'true';
    });
  };
  const setup = () => {
    setupProductAccordions();
    instances.forEach((value, root) => { if (!root.isConnected || !value.track?.isConnected) { value.destroy(); instances.delete(root); } });
    document.querySelectorAll('sb-product-rail, .section-collection-list slider-component, .collection slider-component, .related-products slider-component').forEach(root => {
      if (!instances.has(root)) instances.set(root, new SmartbuzzScroller(root));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  const recommendationObserver = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('.sb-related-slider') || node.querySelector?.('.sb-related-slider'))))) setup();
  });
  recommendationObserver.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((value, root) => { if (event.target.contains(root)) { value.destroy(); instances.delete(root); } });
  });
})();
if (!customElements.get('sb-payment-choice-buy')) {
  customElements.define('sb-payment-choice-buy', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.button = this.querySelector('button');
      this.addButton = this.form?.querySelector('[name="add"]');
      if (!this.form || !this.button || !this.addButton) return;
      this.abort = new AbortController();
      const sync = () => {
        this.button.disabled = !!this.pending || this.addButton.disabled || this.addButton.getAttribute('aria-disabled') === 'true';
      };
      this.observer = new MutationObserver(sync);
      this.observer.observe(this.addButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.button.addEventListener('click', async () => {
        if (this.pending || this.button.disabled || !this.form.reportValidity()) return;
        const productForm = this.closest('product-form');
        productForm?.handleErrorMessage();
        const body = new FormData(this.form);
        if (!body.get('id')) return;
        body.delete('return_to');
        body.delete('sections');
        body.delete('sections_url');
        const label = this.button.textContent;
        this.pending = true;
        sync();
        this.button.textContent = this.button.dataset.loading;
        try {
          const endpoint = new URL(this.form.action);
          endpoint.pathname = endpoint.pathname.replace(/\.js$/, '') + '.js';
          const response = await fetch(endpoint, { method: 'POST', headers: { Accept: 'application/json' }, body });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.button.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          productForm?.handleErrorMessage(error.message || this.button.dataset.error);
          this.pending = false;
          this.button.textContent = label;
          sync();
        }
      }, { signal: this.abort.signal });
      sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
